var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('popover',{attrs:{"content":_vm.judge.title,"trigger":"hover"}},[_vm._v("\n    "+_vm._s(_vm.judge.name)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }